module.exports = __webpack_public_path__ + "static/media/leg-left-side.a9f78eb7.png";